var render = function render(){var _vm=this,_c=_vm._self._c;return _c('header',[_vm._m(0),_c('div',{attrs:{"id":"mapName"}},[_vm._t("default")],2)])
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"divLeft"},[_c('h1',{staticClass:"site-title"},[_c('a',{staticClass:"site-logo",attrs:{"href":"//www.semcog.org"}},[_vm._v(" SEMCOG | Southeast Michigan Council of Governments ")])])])
}]

export { render, staticRenderFns }